import React from 'react';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: boolean;
  helperText?: string;
  fullWidth?: boolean;
  variant?: 'outlined' | 'filled' | 'standard';
  children: React.ReactNode;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      label,
      error = false,
      helperText,
      fullWidth = false,
      variant = 'outlined',
      className = '',
      children,
      ...props
    },
    ref
  ) => {
    const baseClasses = 'rounded-md border bg-card-bg text-text-primary transition-colors focus:outline-none focus:ring-2 px-3 py-2';
    const errorClasses = error
      ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
      : 'border-card-border focus:border-primary focus:ring-primary';

    const selectClasses = [
      baseClasses,
      errorClasses,
      fullWidth ? 'w-full' : '',
      props.disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer',
      className,
    ].filter(Boolean).join(' ');

    return (
      <div className={fullWidth ? 'w-full' : ''}>
        {label && (
          <label className={`block text-sm font-medium mb-1 ${error ? 'text-red-500' : 'text-text-secondary'}`}>
            {label}
            {props.required && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}
        <select
          ref={ref}
          className={selectClasses}
          {...props}
        >
          {children}
        </select>
        {helperText && (
          <p className={`mt-1 text-sm ${error ? 'text-red-500' : 'text-gray-400'}`}>
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

Select.displayName = 'Select';

export default Select;
